export const SET_FIRST_TIME = 'auth/SET_FIRST_TIME'
export const SET_EMAIL = 'auth/SET_EMAIL'
export const SET_LOGIN_STATUS = 'auth/SET_LOGIN_STATUS'
export const SET_SIGNUP_STATUS = 'auth/SET_SIGNUP_STATUS'
export const SET_LOGOUT_STATUS = 'auth/SET_LOGOUT_STATUS'
export const SET_BETA_SUBMITTED = 'auth/SET_BETA_SUBMITTED'
export const SET_CAN_REGISTER = 'auth/SET_CAN_REGISTER'
export const LOGOUT = 'auth/LOGOUT'
export const SET_PASSWORD_RESET_STATUS = 'auth/SET_PASSWORD_RESET_STATUS'
export const SET_RESET_ACTIVATED = 'auth/SET_RESET_ACTIVATED'
export const SET_IS_ANONYMOUS = 'auth/SET_IS_ANONYMOUS'
export const SET_SIGNUP_MESSAGE = 'auth/SET_SIGNUP_MESSAGE'

export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_ERROR = 'auth/LOGIN_ERROR'
export const SET_PASS_SUCCESS = 'auth/SET_PASS_SUCCESS'
export const SET_PASS_ERROR = 'auth/SET_PASS_ERROR'
export const REQUEST_RESET_SUCCESS = 'auth/REQUEST_RESET_SUCCESS'
export const REQUEST_RESET_ERROR = 'auth/REQUEST_RESET_ERROR'
export const PASS_RESET_SUCCESS = 'auth/PASS_RESET_SUCCESS'
export const PASS_RESET_ERROR = 'auth/PASS_RESET_ERROR'
export const SIGNUP_SUCCESS = 'auth/SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'auth/SIGNUP_ERROR'

export const SET_VIEWED_COOKIE_POLICY = 'auth/SET_VIEWED_COOKIE_POLICY'
export const SUBMIT_VIEWED_COOKIE_POLICY = 'auth/SUBMIT_VIEWED_COOKIE_POLICY'


// WEBPACK FOOTER //
// ./assets/auth/actionTypes.js